module.exports = __webpack_public_path__ + "static/media/mob-right.470a1022.png";